import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { ChakraProvider,extendTheme  } from "@chakra-ui/react";
import Four04 from "./components/404/Four04";

import Login from "./components/Auth/Login";
import UserDetails from "./components/Auth/UserDetails";
import Validator from "./components/Auth/Validator";
import Sidebar from "./components/common/Sidebar/Sidebar";
import Cancel from "./components/Terms/Cancellation";
import Privacy from "./components/Terms/Privacy";
import Support from "./components/Terms/Support";
import Terms from "./components/Terms/Terms";


import Refund from "./components/Terms/Refund";
import RedirectDashboard from "./RedirectDashboard";
import { useEffect } from "react";
import { ReactSession } from 'react-client-session';

const fonts = {
    initialColorMode: 'dark',
    useSystemColorMode: false,
    heading: `'Kanit', sans-serif`,
    body: `'Jost', sans-serif`,
    // customTextPoppins: `'Poppins', sans-serif`
  };
const colors = {
    brand: {
        red: "#E33535",
        black: "#111",
        faintGrey: "rgba(255, 255, 255, 0.15)",
        grey: "rgba(255, 255, 255, 0.75)",
        midGrey: "rgba(255, 255, 255, 0.60)",
        lightGrey:"#373737",
        disableGrey: "#606060",
        yellow: "#FBB901",
        white: "#F4F4F4",
        lighterWhite: "#fffc",
        redFade: "rgba(227, 53, 53, 0.2)",
        yellowFade: "rgba(251, 185, 1, 0.2)",
        slate: "#181818",
        green: "#77DD77",
        greenFade: "rgba(144, 238, 144, 0.2)"
    },
    switchYellow: {
      50: "#ECC94B",
      100: "#FBB901",
      200: "#FBB901",
      300: "#FBB901",
      400: "#FBB901",
      500: "#FBB901",
      600: "#FBB901",
      700: "#FBB901",
      800: "#FBB901",
      900: "#FBB901",
    },
};
const theme = extendTheme({
    fonts,colors
});

const ParentComponent = () => {
  const path = window.location.pathname;
  const params = new URLSearchParams(window.location.search);
  const lastNav = params.get('gotopage');
  useEffect(() => {    
    if (lastNav) {
      ReactSession.set("lastNavigate", lastNav);
      
      // Optional: Clean up the URL so the param doesn't sit there
      // window.history.replaceState(null, '', window.location.pathname);
    }
  }, [lastNav]);

  // const network = WalletAdapterNetwork.Devnet;

  // You can also provide a custom RPC endpoint.
  // const endpoint = useMemo(() => clusterApiUrl(network), [network]);

  // const wallets = useMemo(
  //   () => [
  //     /**
  //      * Wallets that implement either of these standards will be available automatically.
  //      *
  //      *   - Solana Mobile Stack Mobile Wallet Adapter Protocol
  //      *     (https://github.com/solana-mobile/mobile-wallet-adapter)
  //      *   - Solana Wallet Standard
  //      *     (https://github.com/solana-labs/wallet-standard)
  //      *
  //      * If you wish to support a wallet that supports neither of those standards,
  //      * instantiate its legacy wallet adapter here. Common legacy adapters can be found
  //      * in the npm package `@solana/wallet-adapter-wallets`.
  //      */
  //     new PhantomWalletAdapter(),
  //     new GlowWalletAdapter(),
  //     new SlopeWalletAdapter(),
  //     new SolflareWalletAdapter({ network }),
  //     new TorusWalletAdapter(),
  //     new LedgerWalletAdapter(),
  //     new SolletExtensionWalletAdapter(),
  //     new SolletWalletAdapter(),
  //     new UnsafeBurnerWalletAdapter(),
  //     new BackpackWalletAdapter()
  //   ],
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  //   [network]
  // );
  return (
    <ChakraProvider theme={theme}>
      <Router>
        {/* {path === "/get-api-key" ||
        path.substring(0, 10) === "/dashboard" ||
        path.substring(0, 6) === "/dummy" ||
        path.substring(0, 5) === "/auth" ? (
          ""
        ) : (
          <Header />
        )} */}
        {/* <Header /> */}
        <Routes>
          <Route exact path="/" element={<Login />} />
          {/* <Route exact path="/team" element={<Teams />} /> */}
          {/* <Route
            exact
            path="/community-projects"
            element={<ExperienceShyft />}
          /> */}
          {/* <Route exact path="/about" element={<About />} /> */}
          {/* <Route exact path="/dashboard" element={<Dashboard />}/> */}
          {/* <Route exact path="/get-api-key" element={<GetAPIKey />}/> */}
          <Route exact path="/get-api-key" element={<Login />} />
          <Route exact path="/auth/:token" element={<Validator />} />
          <Route exact path="/terms" element={<Terms />} />
             
          {/* <Route exact path="/marketplace" element={<MarketplacePage />} /> */}
          {/* <Route exact path="/solana-jupiter-swap-api" element={<JupApisMain />} /> */}
          {/* <Route exact path="/solana-yellowstone-grpc" element={<Grpcstreaming />} />
          <Route exact path="/solana-shreds-rabbitstream" element={<Rabbitstream />} />
          <Route exact path="/solana-dedicated-grpc-nodes" element={<Grpcdedicated />} /> */}
          {/* <Route exact path="/nfts" element={<NftsPage />} /> */}
          <Route exact path="/support" element={<Support />} />
          <Route exact path="/privacy-policy" element={<Privacy />} />
          <Route exact path="/cancellation" element={<Cancel />} />
          <Route exact path="/refund-policy" element={<Refund />} />

          {/* <Route exact path="/solana-rpc-grpc-pricing" element={<PricingDetails />} /> */}
          <Route exact path="/user-details" element={<UserDetails />} />

          <Route
            exact
            path="/:module"
            element={ <Sidebar /> }
            //   // <ConnectionProvider endpoint={endpoint}>
            //     // <WalletProvider wallets={wallets} autoConnect>
            //       {/* <WalletModalProvider> */}
            //         <Sidebar />
            //       {/* </WalletModalProvider> */}
            //     // </WalletProvider>
            //   // </ConnectionProvider>
            // }
          />
          {/* <Route exact path="/paynow" element={<PaymentPage />} />  */}
          <Route exact path="/dashboard" element={<RedirectDashboard />} />
          <Route path="*" element={<Four04 />} />
        </Routes>
        {/* <Footer /> */}
        {/* {path === "/get-api-key" ||
        path.substring(0, 10) === "/dashboard" ||
        path.substring(0, 6) === "/dummy" ||
        path.substring(0, 5) === "/auth" ? (
          <></>
          // <FooterDash />
        ) : (
          <Footer />
        )} */}
      </Router>
    </ChakraProvider>
  );
};

export default ParentComponent;
